import { useState, useEffect } from "react";
import LayoutProvider from "../../../../../providers/LayoutProvider";
import { API_STATUS } from "../../../../../constants";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../../../../../store/slices/auth-slice";
import EndorsementService from "../../../../../services/endorsement.service";
import "../style.scss"
import { getUserApiStatus, setStatusForStudentInstructor } from "../../../../../store/slices/instructor-student.slice";
import SpinnerLoader from "../../../../../components/SpinnerLoader";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import { useAppDispatch } from "../../../../../hooks/app";


function ViewEndorsement() {
    const [endorsement, setEndorsement] = useState<any>({})
    const loading = useSelector(getUserApiStatus)
    const user = useSelector(getUser)
    const dispatch = useAppDispatch()
    const { id } = useParams();
    const BASE_URL = process.env.REACT_APP_API_PROTOCOL + "://" + process.env.REACT_APP_API_HOST

    const getEndorsement = async (id: string) => {
        dispatch(setStatusForStudentInstructor(API_STATUS.LOADING))
        const data: any = await EndorsementService.findById(id)
        if (data) {
            dispatch(setStatusForStudentInstructor(API_STATUS.SUCCEEDED))
            setEndorsement(data)
            return
        }
        dispatch(setStatusForStudentInstructor(API_STATUS.FAILED))
    }

    useEffect(() => {
        if (id) {
            getEndorsement(id)
        }
    }, [id])
    return (
        <LayoutProvider>
            {loading === API_STATUS.LOADING && <SpinnerLoader />}
            <div className="view_endorsement">
                <div className="wrapper">
                    <Row>
                        <Col md={12}>
                            <h2 className="heading2">{endorsement?.name}</h2>
                        </Col>
                        <Col md={12}>
                            <div className="card p-4 rounded-2 bg-white border order-1">
                                <Row>
                                    <Col md={6} className="my-2">
                                        <label><b>Student Name</b></label>
                                        <h6 className="heading-5 mt-1">{user?.firstname} {user?.lastname}</h6>
                                    </Col>
                                    <Col md={6} className="my-2">
                                        <Row>
                                            <Col md={6}>
                                                <label><b>Instructor Name</b></label>
                                                <h6 className="heading-5 mt-1">{endorsement?.instructorId?.firstname} {endorsement?.instructorId?.lastname}</h6>
                                            </Col>
                                            {endorsement?.signature && <Col md={6}>
                                            <label><b>Signature</b></label>
                                                <img className="mt-1" style={{width:"100%"}} src={`${BASE_URL}/uploads/${endorsement?.signature}`} alt="signature" />
                                            </Col>}
                                        </Row>
                                    </Col>
                                    <Col md={6} className="my-2">
                                        <label><b>Certificate</b></label>
                                        <h6 className="heading-5 mt-1">{endorsement?.certificateNo}</h6>
                                    </Col>
                                    <Col md={6} className="my-2">
                                        <label><b>Endorsement Status</b></label>
                                        <h6 className="heading-5 mt-1">{endorsement?.status === true ? "Approved" : "Pending"}</h6>
                                    </Col>
                                    <Col md={6} className="my-2">
                                        <label><b>Date of Endorsement</b></label>
                                        <h6 className="heading-5 mt-1">{moment(endorsement?.entryDate).format('DD MMMM, YYYY')}</h6>
                                    </Col>
                                    <Col md={6} className="my-2">
                                        <label><b>Date of Expiration</b></label>
                                        <h6 className="heading-5 mt-1">{moment(endorsement?.expiryDate).format('DD MMMM, YYYY')}</h6>
                                    </Col>
                                    <Col md={12} className="my-2">
                                        <label><b>Template</b></label>
                                        <p className="heading-5 mt-1">{endorsement?.text}</p>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </LayoutProvider>
    );
}

export default ViewEndorsement;
